import { Stack } from "@justworkshr/milo-core";
import {
  CUSTOMER_IO_CTA_CLICK_EVENT,
  sendCustomerIOEvent,
} from "app/customer-io";
import { oktaAuth, pkceIsEnabled } from "app/okta";
import { useGetCompanyDisplayQuery } from "types/generated/operations";
import ComparisonTable from "../../components/ComparisonTable";
import {
  CF_INTERNATIONAL_SOLUTIONS_EMPLOYER_OF_RECORD_LINK,
  CONVERT_CONTRACTOR_TO_EMPLOYEE_LINK,
  EMPLOYEE_OR_CONTRACTOR_RISKS_OF_MISCLASSIFICATION_LINK,
  INTERNATIONAL_CONTRACTORS_PRODUCT_HELP_LINK,
} from "../../constants";
import styles from "../../InternationalSolutionsPage.module.css";

const Resources = () => {
  const { lgHead, mdFont } = styles;

  const accessToken = pkceIsEnabled() ? oktaAuth.getAccessToken() : "";
  const { data: memberData } = useGetCompanyDisplayQuery();

  const triggerCustomerIOEvent = (ctaName: string, nextUrl: string) => {
    sendCustomerIOEvent(
      {
        event_type: CUSTOMER_IO_CTA_CLICK_EVENT,
        member_uuids: [memberData?.authenticatedMember.uuid ?? ""],
        company_uuids: [memberData?.authenticatedMember.company.uuid ?? ""],
        data: {
          current_url: window.location.href,
          cta_name: ctaName,
          next_url: nextUrl,
        },
      },
      accessToken
    );
  };
  return (
    <Stack spacing="lg" style={{ paddingBottom: "32px" }}>
      <Stack spacing="sm">
        <p className={lgHead}>Compare our global hiring solutions</p>
        <p className={mdFont}>
          Onboard and pay contractors in over 60 countries and counting, or hire
          full-time international employees with our Employer of Record (EOR)
          services.{" "}
          <a href={CF_INTERNATIONAL_SOLUTIONS_EMPLOYER_OF_RECORD_LINK}>
            Learn more about EOR
          </a>
        </p>
        <ComparisonTable />
      </Stack>
      <Stack spacing="sm">
        <p className={lgHead}>Read more</p>
        <p className={mdFont}>
          <a
            href={INTERNATIONAL_CONTRACTORS_PRODUCT_HELP_LINK}
            target="_blank"
            onClick={() => {
              triggerCustomerIOEvent(
                "eor_contractors_international_contractors_help_center_article_link",
                INTERNATIONAL_CONTRACTORS_PRODUCT_HELP_LINK
              );
            }}
          >
            International contractors help center article
          </a>
        </p>
        <p className={mdFont}>
          <a
            href={EMPLOYEE_OR_CONTRACTOR_RISKS_OF_MISCLASSIFICATION_LINK}
            target="_blank"
            onClick={() => {
              triggerCustomerIOEvent(
                "eor_contractors_employee_or_contractor_blog_link",
                EMPLOYEE_OR_CONTRACTOR_RISKS_OF_MISCLASSIFICATION_LINK
              );
            }}
          >
            Employee or contractor? Understanding the risks of misclassification
          </a>
        </p>
        <p className={mdFont}>
          <a
            href={CONVERT_CONTRACTOR_TO_EMPLOYEE_LINK}
            target="_blank"
            onClick={() => {
              triggerCustomerIOEvent(
                "eor_contractors_how_to_convert_international_contractor_to_fte_blog_link",
                CONVERT_CONTRACTOR_TO_EMPLOYEE_LINK
              );
            }}
          >
            How to convert an international contractor to a full-time employee
          </a>
        </p>
      </Stack>
    </Stack>
  );
};

export default Resources;
